import { render, staticRenderFns } from "./QPagination.vue?vue&type=template&id=3f11a526&"
import script from "./QPagination.vue?vue&type=script&lang=js&"
export * from "./QPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports